module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Chart-bar#2-f47357c3b63a1044518bda57e195bd08.svg";